export default __webpack_public_path__ + "static/media/clock_face.ff14718b.png";